/* eslint-disable no-useless-catch */
import axios from "axios";

const baseUrl = "https://ub1.snappaisa.com/api";
// const baseUrl = "https://backend.snappaisa.com/api";
// const baseUrl = "http://localhost:8083/api";


// Get environment variables
export const API_URL = `${baseUrl}/`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor for logging
api.interceptors.request.use((config) => {
  // console.log("API Request:", config);
  return config;
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  // Try to get token from localStorage (prefer "token" key, fallback to "authToken" / "authtoken")
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("authtoken");

  if (token) {
    config.headers.Authtoken = token;
    config.headers.authtoken = token;
  } else {
    delete config.headers.Authtoken;
    delete config.headers.authtoken;
  }

  config.headers.Accept = "application/json";
  config.headers["Content-Type"] = "application/json; charset=UTF-8";
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    // console.log("API Response:", response);
    return response;
  },
  (error) => {
    // Handle session expired or unauthorized errors
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear tokens and redirect to login
      localStorage.removeItem("token");
      localStorage.removeItem("authToken");
      localStorage.removeItem("authtoken");
      // Redirect to mobile page if not already there
      if (window.location.pathname !== '/apply-now' && window.location.pathname !== '/otp') {
        window.location.href = '/apply-now';
      }
    }
    // console.error("API Error:", error);
    return Promise.reject(error);
  }
);

// Auth related API calls
export const authAPI = {
  sendOTP: async (data) => {
    try {
      // Format data according to API requirements
      const formattedData = {
        mobile: data.mobile.trim(),
        event_name: "login",
        utm_source: data.utm_source || "",
        utm_medium: data.utm_medium || "",
        utm_campaign: data.utm_campaign || "",
        utm_content: data.utm_content || "",
        utm_term: data.utm_term || "",
        clickid: data.clickid || "",
      };

      // console.log("Sending OTP request with data:", formattedData);
      const response = await api.post(
        "/Api/Website/InstantJourneyController/appCustomerRegisteration",
        formattedData
      );
      return response.data;
    } catch (error) {
      // console.log("error-api >>>>>> ", error);
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  verifyOTP: async (data) => {
    try {
      const formattedData = {
        event_name: "otp_verify",
        profile_id: data.profile_id,
        otp: data.otp,
        geo_lat: data.geo_lat || "",
        geo_long: data.geo_long || "",
        utm_source: data.utm_source || "",
        utm_medium: data.utm_medium || "",
        utm_campaign: data.utm_campaign || "",
        utm_content: data.utm_content || "",
        utm_term: data.utm_term || "",
        click_id: data.clickid || data.click_id || "",
      };

      // console.log("Verify OTP request with data:", formattedData);
      const response = await api.post(
        "/Api/Website/InstantJourneyController/appCustomerRegisteration",
        formattedData
      );
      // console.log("Verify OTP Response:", response.data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 422) {
        throw new Error("Invalid OTP");
      } else if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      // console.error("Verify OTP Error:", error.response?.data);
      throw error;
    }
  },

  resendOTP: async (data) => {
    try {
      const formattedData = {
        mobile: data.mobile.trim(),
        event_name: "login",
        utm_source: data.utm_source || "",
        utm_medium: data.utm_medium || "",
        utm_campaign: data.utm_campaign || "",
        utm_content: data.utm_content || "",
        utm_term: data.utm_term || "",
        clickid: data.clickid || "",
      };
      const response = await api.post(
        "/Api/Website/InstantJourneyController/appCustomerRegisteration",
        formattedData
      );
      return response.data;
    } catch (error) {
      // console.error("Resend OTP Error:", error.response?.data);
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  verifyPAN: async (data) => {
    try {
      const formattedData = {
        event_name: "pancard_verification",
        pancard: data.pancard.trim().toUpperCase(),
        profile_id: data.profile_id,
        monthly_income: data.monthly_income || "",
        geo_lat: data.geo_lat || "",
        geo_long: data.geo_long || "",
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/appCustomerRegisteration",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  submitPersonalDetails: async (data) => {
    try {
      const formattedData = {
        event_name: "personal_details",
        profile_id: data.profile_id,
        dob: data.dob,
        income_type_id: data.income_type_id,
        salary_mode_id: data.salary_mode_id,
        monthly_income: data.monthly_income,
        personal_email: data.personal_email,
        residence_pincode: data.residence_pincode,
        father_name: data.father_name || "",
        geo_lat: data.geo_lat || "",
        geo_long: data.geo_long || "",
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/appCustomerRegisteration",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  uploadSelfie: async (data) => {
    try {
      const formattedData = {
        event_name: "selfie_upload",
        profile_id: data.profile_id,
        file: data.file,
        file_ext: data.file_ext || "jpeg",
        geo_lat: data.geo_lat || "",
        geo_long: data.geo_long || "",
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/appCustomerRegisteration",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  submitOtherInformation: async (data) => {
    try {
      const formattedData = {
        event_name: "employment_details",
        profile_id: data.profile_id,
        residence_type_id: data.residence_type_id,
        residence_address_1: data.residence_address_1,
        residence_address_2: data.residence_address_2 || "",
        residence_landmark: data.residence_landmark || "",
        residence_pincode: data.residence_pincode || "",
        company_name: data.company_name,
        office_email: data.office_email,
        designation: data.designation,
        department: data.department || "",
        account_ifsc: data.account_ifsc,
        emp_address_1: data.emp_address_1 || "",
        emp_address_2: data.emp_address_2 || "",
        emp_landmark: data.emp_landmark || "",
        emp_pincode: data.emp_pincode || "",
        work_mode: data.work_mode || "",
        geo_lat: data.geo_lat || "",
        geo_long: data.geo_long || "",
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/saveleadDetails",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  getDashboardData: async (profile_id) => {
    try {
      const response = await api.post(
        "/Api/Website/InstantJourneyController/getDashboardData",
        { profile_id }
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  getLeadList: async (profile_id, pancard) => {
    try {
      const response = await api.post(
        "/Api/Website/InstantJourneyController/getLeadList",
        { profile_id, pancard }
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  saveBankingDetails: async (data) => {
    try {
      const formattedData = {
        event_name: "banking_details",
        profile_id: data.profile_id,
        lead_id: data.lead_id,
        account_number: data.account_number,
        confirm_account_number: data.confirm_account_number,
        account_ifsc: data.account_ifsc || "",
        account_branch: data.account_branch || "",
        account_type_id: 1,
        acc_type: 1,
        verification_consent: 1,
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/saveleadDetails",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  registerNow: async (data) => {
    try {
      const formattedData = {
        profile_id: data.profile_id,
        event_name: "register_now",
        geo_lat: data.geo_lat || "",
        geo_long: data.geo_long || "",
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/appCustomerRegisteration",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  initiateAccountAggregator: async (data) => {
    try {
      const formattedData = {
        lead_id: data.lead_id || "",
        profile_id: data.profile_id,
        custom_domain: "https://snappaisa.com/",
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/initiate_account_agreegator",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  checkAccountAggregatorStatus: async (data) => {
    try {
      const formattedData = {
        profile_id: data.profile_id,
        lead_id: data.lead_id,
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/check_account_agreegator_status",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  initiateEkyc: async (data) => {
    try {
      const formattedData = {
        lead_id: data.lead_id || "",
        profile_id: data.profile_id,
        custom_domain: "https://snappaisa.com/",
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/initiate_ekyc",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  checkEkycStatus: async (data) => {
    try {
      const formattedData = {
        profile_id: data.profile_id,
        lead_id: data.lead_id,
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/check_ekyc_status",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },

  uploadBankStatement: async (data) => {
    try {
      const formattedData = {
        profile_id: data.profile_id,
        event_name: data.event_name || "bank_statement_upload",
        file_ext: data.file_ext || "pdf",
        file: data.file,
      };

      const response = await api.post(
        "/Api/Website/InstantJourneyController/saveleadDetails",
        formattedData
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.Message) {
        throw new Error(error.response.data.Message);
      }
      throw error;
    }
  },
};


// ==================== SquidLoans / Automation Node API (same base URL as dhanrishi_web_frontend) ====================
// Separate axios instance + APIs matching the original dhanrishi_web_frontend logic
// const squidloan_api_url = "https://ub1.snappaisa.com/api";
const squidloan_api_url = `${baseUrl}`

const squidloansApi = axios.create({
  baseURL: squidloan_api_url,
  headers: {
    "Content-Type": "application/json",
  },
});

squidloansApi.interceptors.request.use((config) => {
  // Try to get token from localStorage (prefer "authToken", fallback to "token" / "authtoken")
  const token =
    localStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    localStorage.getItem("authtoken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth-style APIs for SquidLoans automation flow (PAN + mobile OTP)
export const squidloansAuthAPI = {
  sendOTP: async (data) => {
    try {
      const formattedData = {
        PAN: data.PAN?.trim().toUpperCase(),
        phone_number: data.phone_number?.trim(),
        lat: data.lat ?? undefined,
        lng: data.lng ?? undefined,
      };
      const response = await squidloansApi.post("/user/send-otp", formattedData);
      return response;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  verifyOTP: async (data) => {
    try {
      const response = await squidloansApi.post("/user/verify-otp", data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 422) {
        throw new Error("Invalid OTP");
      }
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  resendOTP: async (data) => {
    try {
      const formattedData = {
        PAN: data.PAN?.trim().toUpperCase(),
        phone_number: data.phone_number?.trim(),
      };
      const response = await squidloansApi.post("/user/send-otp", formattedData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },
};

// User / journey APIs for SquidLoans automation flow
// Mirrors the original dhanrishi_web_frontend userAPI, but uses squidloansApi/squidloan_api_url
export const squidloansUserAPI = {
  initiateKYC: async (data) => {
    try {
      const response = await squidloansApi.post("/user/initiate-kyc", data);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  submitAadharOTP: async (data) => {
    try {
      const response = await squidloansApi.post("/user/submit-aadhar-otp", data, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getJourney: async () => {
    try {
      const response = await squidloansApi.get("/user/get-journey");
      return response.data;
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        // Clear all token variations
        localStorage.removeItem("authToken");
        localStorage.removeItem("token");
        localStorage.removeItem("authtoken");
        // Only redirect if it's a 401 (unauthorized), not 403 (forbidden)
        if (error.response?.status === 401) {
          window.location.href = "/";
        }
      }
      throw error;
    }
  },

  addEmployment: async (data) => {
    try {
      const response = await squidloansApi.post("/user/add-employement", data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 301) {
        window.location.href = "/apply/thank-you";
      }
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  // GC SSO partial-registration page: fills company/salary-date/official-email
  // (+ optional lat/lng) and advances the lead to VERIFY_EMAIL_OTP.
  fillPartialEmploymentDetails: async (data) => {
    try {
      const response = await squidloansApi.post(
        "/user/fill-partial-employment-details",
        data
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  verifyEmail: async (data) => {
    try {
      const response = await squidloansApi.post("/user/verify-email", data);
      if (!response || !response.data) {
        throw new Error("Invalid response from server");
      }
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  previewSanction: async () => {
    try {
      const response = await squidloansApi.post("/user/preview-sanction");
      return response;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  checkDisbursalStatus: async () => {
    try {
      const response = await squidloansApi.get("/user/check-disbursal-status");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getRedirectUrl: async () => {
    try {
      const response = await squidloansApi.post(
        "/user/redirect-url",
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  disbursed: async (data) => {
    try {
      const response = await squidloansApi.post("/user/disbursed", data);
      return response;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  transactionLoyalty: async () => {
    try {
      try {
        await squidloansApi.post("/user/send-transaction");
      } catch (error) {
        console.error("Error in send-transaction:", error);
        throw new Error("Error in reward points.");
      }
      try {
        await squidloansApi.post("/user/partial-transaction");
      } catch (error) {
        console.error("Error in partial-transaction:", error);
        throw new Error("Error in reward points.");
      }
      return true;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getLoanStatus: async () => {
    try {
      const response = await squidloansApi.get("/user/loan-status");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getESignData: async () => {
    try {
      const response = await squidloansApi.get("/user/loan-details");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getProfile: async () => {
    try {
      const response = await axios.get(`${squidloan_api_url}/user/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  requestLoan: async (data) => {
    try {
      const response = await squidloansApi.post("/user/request-loan", data);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  logout: async () => {
    try {
      const response = await axios.post(
        `${squidloan_api_url}/user/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  uploadBankStatement: async (file, password) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await squidloansApi.post("/user/upload-bank-statement", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          password: password,
        },
        timeout: 300000,
        onUploadProgress: (progressEvent) => {
          // Upload progress tracking (can be used for progress bars in future)
          Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  contactUs: async (data) => {
    try {
      const response = await squidloansApi.post("/user/contact-us", data);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        "Something went wrong. Please try again.";
      throw new Error(message);
    }
  },

  getCongratulationData: async () => {
    try {
      const response = await squidloansApi.get("/user/congratulation-page");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  submitFeedback: async (data) => {
    try {
      const response = await squidloansApi.post("/user/submit-feedback", data);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  sendFeedback: async (data) => {
    try {
      const response = await squidloansApi.post("/user/submit-feedback", data);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  addReference: async (data) => {
    try {
      const response = await squidloansApi.post("/user/add-refrence", data);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getRequestedLoanAmount: async () => {
    try {
      const response = await squidloansApi.get("/user/request-loan-amount");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  applyReloan: async () => {
    try {
      const response = await squidloansApi.post("/user/apply-reloan");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getSanctionLetter: async () => {
    try {
      const response = await squidloansApi.get("/user/get-sanction-letter");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  repay: async () => {
    try {
      // console.log("Requesting PayU payment...");
      const response = await squidloansApi.post("/user/create-order");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      // console.error("Error getting repayment link:", error);
      throw error;
    }
  },

  sendOtpForPaynow: async (PAN) => {
    try {
      const response = await squidloansApi.post("/user/send-otp-for-paynow", {
        PAN: PAN?.trim().toUpperCase(),
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  verifyOtpForPaynow: async (data) => {
    try {
      const response = await squidloansApi.post("/user/verify-otp-for-paynow", {
        PAN: data.PAN?.trim().toUpperCase(),
        otp: data.otp?.trim(),
        phone_number: data.phone_number?.trim(),
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getRepaymentDates: async (loan_amount, is_opted_insurance = true) => {
    try {
      const response = await squidloansApi.post("/user/repayment-dates", {
        loan_amount,
        is_opted_insurance,
      });
      return response.data.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  addSurvey: async (data) => {
    try {
      const response = await squidloansApi.post("/user/add-survey", data);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  loanHistory: async () => {
    try {
      const response = await squidloansApi.get("/user/loan-history");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getLoyaltyPoints: async () => {
    try {
      const response = await squidloansApi.get("/user/fetch_loyalty_points");
      return response.data.data.points_balance;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getAddresses: async () => {
    try {
      const response = await squidloansApi.get("/user/fetch_address");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  saveSelectedAddress: async (addressData) => {
    try {
      const payload = {
        address: addressData.address,
        state: addressData.state,
        city: addressData.city,
        pincode: addressData.pincode,
      };
      const response = await squidloansApi.post("/user/saved-Address", payload);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  generateBankingUrl: async ({ bankName, salaryAccountLinkedPhoneNo, institutionId }) => {
    try {
      const payload = {
        bankName,
        salaryAccountLinkedPhoneNo,
        institutionId,
      };
      const response = await squidloansApi.post("/user/generate-banking-url", payload);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  verifyManualAddress: async (addressData) => {
    try {
      const payload = {
        address: addressData.address,
        state: addressData.state,
        city: addressData.city,
        pincode: addressData.pincode,
      };
      const response = await squidloansApi.post("/user/verify-manual-address", payload);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  verifyCouponCode: async (couponCode) => {
    try {
      const response = await squidloansApi.post("/user/coupon-no-verify", {
        couponCode: couponCode.trim().toUpperCase(),
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  applyCouponCode: async (couponCode) => {
    try {
      const response = await squidloansApi.post("/user/coupon-no", {
        couponCode: couponCode.trim().toUpperCase(),
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getRewardsAccessKey: async () => {
    try {
      const response = await squidloansApi.post("/user/loyalty_points");
      return response.data.accessKey;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  checkAAStatus: async ({ request_id, txn_id, status }) => {
    try {
      const payload = { request_id, txn_id, status };
      const response = await squidloansApi.post("/user/check-aa-status", payload);
      return response.data;
    } catch (error) {
      const data = error.response?.data;
      if (
        error.response?.status === 400 &&
        data &&
        (data.status ||
          data.is_aa_failed !== undefined ||
          data.is_bre_reject !== undefined ||
          data.is_hard_reject !== undefined)
      ) {
        return data;
      }
      if (data?.message) {
        throw new Error(data.message);
      }
      throw error;
    }
  },

  /**
   * Initiates AA consent flow and returns redirect URL.
   * No request body required. Handles authentication and lead validation automatically.
   */
  redirectAA: async () => {
    try {
      const response = await squidloansApi.post("user/cams/redirect-aa");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  /**
   * Performs loan eligibility assessment (BSA and BRE decisions).
   * No request body required. May take 10-30 seconds to complete.
   * Returns loan amount (if approved) or rejection status.
   */
  loanDecisioning: async () => {
    try {
      const response = await squidloansApi.post("user/cams/loan-decisioning");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  verifyPennyDrop: async ({ accountNumber, ifscCode, beneficiaryName }) => {
    try {
      const payload = {
        accountNumber,
        ifscCode,
        beneficiaryName,
      };
      const response = await squidloansApi.post("/user/penny-drop-verification", payload);
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  getAccountNumber: async () => {
    try {
      const response = await squidloansApi.get("/user/account-no");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  createRazorpayOrder: async () => {
    try {
      const response = await squidloansApi.post("/user/create-order");
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  },

  uploadAddressProof: async (file) => {
    try {
      const formData = new FormData();
      formData.append("addressProof", file);

      const response = await squidloansApi.post("/user/upload-address-proof", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          // Upload progress tracking (can be used for progress bars in future)
          Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error(error.response?.data?.message || error.message);
    }
  },

  uploadKYCDocuments: async ({ panFront, panBack, selfie }) => {
    try {
      const formData = new FormData();
      formData.append("pan_front", panFront);
      formData.append("pan_back", panBack);
      formData.append("selfie", selfie);

      const response = await squidloansApi.post("/user/upload-kyc-documents", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error(error.response?.data?.message || error.message);
    }
  },
};

// Alias for components expecting userAPI (automation flow, dashboard, etc.)
export const userAPI = squidloansUserAPI;

export default api;

